export const tableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('common:table.name'),
  },
  {
    id: 'scope',
    type: 'text',
    value: t('dashboard:ropa.table.scope'),
  },
  {
    id: 'date',
    type: 'datebr',
    value: t('common:table.date'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
